import { Box } from "@mui/material";
import React, { useState } from "react";
import { Navigate, Outlet } from "react-router";
import LoadingPage from "../../common/components/common/LoadingPage";
import { getDataSession, LOCAL_STORAGE } from "../../helper/session";
import Footer from "./Footer";
import { HeaderMenu } from "./HeaderMenu";
import LeftMenu from "./LeftMenu";

const ThemeLayout = (props) => {
  const { outlet } = props;
  const [openLeftMenu, setOpenLeftMenu] = useState(true);
  const isLogin = getDataSession(LOCAL_STORAGE, "isLogin");
  // const { isAvailableRoute } = useCurrenPath();

  if (!isLogin) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <Box
        className="flex flex-row flex-1 relative "
        style={{ minHeight: "100vh" }}
      >
        <LeftMenu open={openLeftMenu} onClose={() => setOpenLeftMenu(false)} />
        <Box
          className="w-full"
          style={{ maxHeight: "100vh", overflow: "auto" }}
        >
          <HeaderMenu />
          <Box
            className="h-[calc(100vh-3.875rem)] flex justify-between flex-col"
            // style={{ height: "100%", justifyContent: "space-between" }}
          >
            <React.Suspense fallback={<LoadingPage />}>
              {outlet ?? <Outlet />}
            </React.Suspense>
            <Footer />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ThemeLayout;
